<template>
  <div id="pers-tab8" name="hres31x-tab8" class="content-pers" :class="{'-fixed-height-box' : pcDisp}">

    <!--Start Topic #1-->
    <div class="sub-topic-box color-skin" @click="toggleSubTopic1">
      <i class="fa fa-user icon-sub-topic" aria-hidden="true"></i>
      <div class="sub-topic">{{ labels['HRES31XC8']['20'] }}</div>
    </div>

    <div class="data-pers-box" v-show="subTopic1">
      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC8']['30'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['namfathr'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC8']['220'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['numofidf'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC8']['50'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['codfrelg'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC8']['40'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['codfnatn'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC8']['60'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['codfoccu'] }}</div>
      </div>
    </div>
    <!--End Topic #1-->
    <!--Start Topic #2-->
    <div class="sub-topic-box color-skin" @click="toggleSubTopic2">
      <i class="fa fa-user icon-sub-topic" aria-hidden="true"></i>
      <div class="sub-topic">{{ labels['HRES31XC8']['70'] }}</div>
    </div>

    <div class="data-pers-box" v-show="subTopic2">
      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC8']['80'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['nammothr'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC8']['230'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['numofidm'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC8']['100'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['codmrelg'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC8']['90'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['codmnatn'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC8']['110'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['codmoccu'] }}</div>
      </div>
    </div>
    <!--End Topic #2-->
    <!--Start Topic #3-->
    <div class="sub-topic-box color-skin" @click="toggleSubTopic3">
      <i class="fa fa-user icon-sub-topic" aria-hidden="true"></i>
      <div class="sub-topic">{{ labels['HRES31XC8']['120'] }}</div>
    </div>

    <div class="data-pers-box" v-show="subTopic3">
      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC8']['130'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['namcont'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC8']['140'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['desrelat'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC8']['150'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['adrcont1'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC8']['160'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['codpost'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC8']['170'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['numtele'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC8']['180'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['numfax'] }}</div>
      </div>

      <div class="row data-box">
        <div class="col-xs-6 data-label">{{ labels['HRES31XC8']['190'] }}</div>
        <div class="col-xs-6 data-text">{{ detail['email'] }}</div>
      </div>
    </div>
    <!--End Topic #3-->
  </div>
</template>

<script>
export default {
  name: 'hres31x-tab8',
  data () {
    return {
      subTopic1: true,
      subTopic2: true,
      subTopic3: true
    }
  },
  methods: {
    toggleSubTopic1 () {
      this.subTopic1 = !this.subTopic1
    },
    toggleSubTopic2 () {
      this.subTopic2 = !this.subTopic2
    },
    toggleSubTopic3 () {
      this.subTopic3 = !this.subTopic3
    }
  },
  props: [ 'nowLang', 'labels', 'detail', 'pcDisp', 'togglePage', 'triggerButton' ]
}
</script>


// WEBPACK FOOTER //
// tab8.vue?b3184328